@if (!dataConnectionError && status === 'loaded') {
    <div class="d-flex align-items-center mb-3">
        <wdx-search-input
            class="w-100 me-3"
            (wdxChanged)="search($event)"
        ></wdx-search-input>

        <div class="d-flex align-items-center text-nowrap">
            {{ 'PORTFOLIO_POSITIONS_GROUP_BY' | translateTokenisedString }}:

            <wdx-dropdown
                ngbDropdown
                container="body"
                #dropdown="ngbDropdown"
                class="ms-2"
            >
                <button
                    ngbDropdownToggle
                    [wdxButton]="WdxButtonStyle.Link"
                    class="align-items-center"
                >
                    <span class="ms-1 fw-bold fs-5">
                        {{
                            groupByOptions[selectedGroupby].label
                                | translateTokenisedString
                        }}
                    </span>
                    <wdx-icon
                        class="ms-2 toggle-icon"
                        icon="chevron-down"
                    ></wdx-icon>
                </button>
                <wdx-dropdown-menu ngbDropdownMenu>
                    @for (
                        option of groupByOptions;
                        track $index;
                        let i = $index
                    ) {
                        <button
                            class="d-flex"
                            ngbDropdownItem
                            (click)="onGroupBySelection(option, i)"
                        >
                            {{ option.label | translateTokenisedString }}
                        </button>
                    }
                </wdx-dropdown-menu>
            </wdx-dropdown>
        </div>
    </div>

    @if (colDefs) {
        <ag-grid-angular
            wdxUtilsAgGridTheme
            [rowData]="filteredRowData"
            [columnDefs]="colDefs"
            [gridOptions]="gridOptions"
            [autoGroupColumnDef]="autoGroupColumnDef"
            class="w-100"
            data-cy="positions-table"
        >
        </ag-grid-angular>
    }
} @else {
    <wdx-portfolio-not-loaded
        [status]="dataConnectionError ? 'dataConnectionError' : status"
        [connectionErrorMessage]="dataConnectionError?.detail ?? ''"
        [dataTypeLabel]="dataTypeLabel"
    ></wdx-portfolio-not-loaded>
}
